import React, { useState } from "react"
import { Link } from "react-router-dom";
import useEasterEgg from "utils/hooks/useEasterEgg";
import PageHeaders from "../common/PageHeaders"
import Menu from "../common/Menu"
import Header from "../components/Header"
import Footer from "../components/Footer"
import scott from "../images/peeps/scott.webp";

const About = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const { eggs } = useEasterEgg([
    {
      string: "scott",
      image: scott,
      logMessage: "scott, we miss you!",
    },
  ]);

  return (
    <>
      <PageHeaders type="support"/>
      <div className="flex flex-col h-full" id="outer-container">
        <div className={`relative ${!!menuOpen ? "" : "max-w-page"}`}>
          <Menu
            handleToggle={state => {
              setMenuOpen(state.isOpen)
            }}
            hidden={menuOpen}
          />
        </div>
        <div className="topSection bkgDark" id="page-wrap">
          <div className="headerBar">
            <Header siteTitle={"Support"} />
          </div>
          <div className="flex mt-32 lg:mt-24">
            <main className="w-full text-dark md:pt-16">
                      <section className="mb-20 px-10 max-w-page text-center py-5">
                        <p className="text-xl text-primary font-bold  mb-2 uppercase">support</p>
                        <h1 className="text-3xl md:text-5xl text-white font-bold w-10/12 mx-auto">
                         Get in touch
                        </h1>
                        <p className="md:text-2xl font-light mt-2 w-full md:w-8/12 mx-auto text-white"> We are always happy to receive your input. You may
                        contact us for help and support in any of the following
                        ways:</p>
                      </section>
                    <section className="w-full bg-white px-10 py-12">
                    <div className="max-w-page md:flex md:items-start">

                    {/*<section className="px-5 flex-1 text-center">
                      <h3 className="font-bold  text-xl mb-2"> Phone:</h3>
                      <p><a href="tel:+18664327695">+1 (866) 432-7695</a></p>
                      <p className="mt-2">
                        <b>Hours of operation:</b> <br />9am-5pm PT, Monday through Friday.
                      </p>

                    </section>*/}
                    <section className="px-5 flex-1 text-center">
                    <h3 className="font-bold  text-xl mb-2 mt-5"> Email:</h3>
                      <p>
                        Feel free to email us any time! <br /><a href="mailto:help@tomocredit.com">
                          help@tomocredit.com
                        </a>
                      </p>
                    </section>
                    <section className="px-5 flex-1 text-center">
                      <h3 className="font-bold  text-xl mb-2 mt-8 md:mt-5"> Location:</h3>
                      <p>
                        TomoCredit Inc
                        <br />
                        PO BOX 194807
                        <br />
                        San Francisco, CA 94119
                      </p>
                    </section>

                    <section className="px-5 flex-1 text-center">
                      <h3 className="font-bold  text-xl mb-2 mt-8 md:mt-5"> Have Questions?</h3>
                      <Link to="/faq">
                        <button className="bg-primary text-white cursor-pointer px-3 py-3 shadow-xl font-bold text-base md:text-md rounded-lg mt-5 hover:shadow-none w-full md:w-8/12">
                       View our FAQs</button>
                      </Link>

                      <Link to="/application-troubleshooting">
                        <button className="bkgDark text-white cursor-pointer px-3 py-3 shadow-xl font-bold text-md rounded-lg mt-5 hover:shadow-none w-full md:w-8/12">
                        Application Help</button>
                      </Link>
                    </section>
                  </div>
                    </section>
            </main>
          </div>
        </div>
        {eggs}
        <Footer />
      </div>
    </>
  )
}

export default About
